import { Module } from '@core/interfaces/entities/module.interface';
import { ModuleDto } from '@core/dtos/module.dto';
import { Mapper } from './mapper';
import { Injectable } from '@angular/core';

/**
 * Mapper para convertir entre la entidad Module de la API
 * y el DTO de ModuleDto utilizado en el Cliente.
 *
 * @extends {Mapper<Module, ModuleDto>}
 */
@Injectable({
  providedIn: 'root',
})
export class ModuleMapper extends Mapper<Module, ModuleDto> {
  /**
   * Mapea un objeto de la entidad 'Module' que proviene de la API
   * a un 'ModuleDto' para ser usado en el Cliente.
   *
   * @param data El objeto de la entidad 'Module' a mapear.
   * @returns Un Dto de 'ModuleDto' listo para ser usado en el Cliente.
   */
  mapFrom(data: Module): ModuleDto {
    return {
      id: data.id,
      icon: data.icon,
      name: data.name,
      active: data.active,
      hidden: data.hidden,
      title: data.title,
      url: data.url,
      labelKey: data.label_key,
      sideMenuGroup: data.side_menu_group,
    };
  }

  /**
   * Mapea un objeto 'ModuleDto' del Cliente de vuelta
   * a un objeto de la entidad 'Module' para enviar a la API.
   *
   * @param data El Dto de 'ModuleDto' a mapear.
   * @returns Un objeto de la entidad 'Module' listo para enviar a la API.
   */
  override mapTo(data: ModuleDto): Module {
    return {
      id: data.id,
      icon: data.icon,
      name: data.name,
      active: data.active,
      hidden: data.hidden,
      title: data.title,
      url: data.url,
      label_key: data.labelKey,
    };
  }
}
